import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"
import Icon from "./elements/Icon"

function PageLink({ onClick, href, className = "", ariaLabel, children, ariaCurrent }) {
    return (
        <a
            class={`ns-page-link ns-d-block ns-relative ns-text-undecorated ns-clickable ns-py-2 ns-px-4 ns-color-black ns-border-radius-3 ${className}`}
            href={href}
            aria-label={ariaLabel}
            aria-current={ariaCurrent}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({
        width: 5
    })

    const { updateSearch, simulateUpdateSearch } = useActions()

    function pageLinkProps({ from }) {
        return {
            onClick: e => {
                e.preventDefault();
                updateSearch({ products: { from } });
                scrollTo(0, 0);
            },
            href: simulateUpdateSearch({ products: { from } }).url
        }
    }

    return (
        <nav aria-label="Search results pagination" role="navigation">
            <ul class="ns-d-flex ns-flex-wrap ns-justify-content-center ns-list-unstyled ns-m-0 ns-p-0 ns-mx-0">
            {prev && (
                <li class="ns-d-flex ns-align-items-center">
                    <PageLink {...pageLinkProps(prev)} className="ns-previous" ariaLabel="Previous page">
                        {/* <Icon name="arrow" className="ns-page-prev-icon" /> */}
                        <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="rotate-180 w-4.5 h-4.5">
                            <path d="M12 1L18 7L12 13" stroke="currentColor"></path>
                            <path d="M18 7H0" stroke="currentColor"></path>
                        </svg>
                    </PageLink>
                </li>
            )}

            {first && (
                <>
                    <li>
                        <PageLink {...pageLinkProps(first)} ariaLabel="First page">
                            {first.page}
                        </PageLink>
                    </li>
                    <li><span class="ns-d-block ns-py-2 ns-px-4">...</span></li>
                </>
            )}

            {pages.map(page => (
                // ns-background-primary-light
                <li key={page.page} class={`${page.current ? "ns-active ns-color-black" : ""}`}>
                    <PageLink 
                        ariaLabel={page.current ? `Current page ${page.page}` : `Go to page ${page.page}`} 
                        {...pageLinkProps(page)}
                        className={page.current ? "ns-page-link-current" : ""}
                        ariaCurrent={page.current ? "page" : undefined}
                    >
                        {page.page}
                    </PageLink>
                </li>
            ))}

            {last && (
                <>
                    <li class="ns-d-flex ns-align-items-center"><span class="ns-py-2 ns-px-4">...</span></li>
                    <li>
                        <PageLink {...pageLinkProps(last)} ariaLabel="Last page">{last.page}</PageLink>
                    </li>
                </>
            )}

            {next && (
                <li class="ns-d-flex ns-align-items-center">
                    <PageLink {...pageLinkProps(next)} className="ns-next" ariaLabel="Next page">
                        {/* <Icon name="arrow" className="ns-page-next-icon" /> */}
                        <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5">
                            <path d="M12 1L18 7L12 13" stroke="currentColor"></path>
                            <path d="M18 7H0" stroke="currentColor"></path>
                        </svg>
                    </PageLink>
                </li>
            )}
            </ul>
        </nav>
    )
}


// version commented on October 2nd to adapt code for ADA compliance


// import { usePagination, useActions } from "@nosto/preact"
// import Icon from "./elements/Icon"

// function PageLink({ onClick, href, className, ariaLabel, children }) {
//     return (
//         <a
//             class={`ns-page-link ns-d-block ns-relative ns-text-undecorated ns-clickable ns-py-2 ns-px-4 ns-color-black ns-border-radius-3 ${className}`}
//             href={href}
//             aria-label={ariaLabel}
//             onClick={onClick}
//         >
//             {children}
//         </a>
//     )
// }

// export default function Pagination() {
//     const { prev, first, pages, last, next } = usePagination({
//         width: 5
//     })

//     const { updateSearch, simulateUpdateSearch } = useActions()

//     function pageLinkProps({ from }) {
//         return {
//             onClick: e => {
//                 e.preventDefault();
//                 updateSearch({ products: { from } });
//                 scrollTo(0, 0);
//             },
//             href: simulateUpdateSearch({ products: { from } }).url
//         }
//     }

//     return (
//         // ns-my-2
//         <ul class="ns-d-flex ns-flex-wrap ns-justify-content-center ns-list-unstyled ns-m-0 ns-p-0 ns-mx-0">
//             {prev && (
//                 <li class="ns-d-flex ns-align-items-center">
//                     <PageLink {...pageLinkProps(prev)} className="ns-previous" ariaLabel="Previous page">
//                         {/* <Icon name="arrow" className="ns-page-prev-icon" /> */}
//                         <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="rotate-180 w-4.5 h-4.5">
//                             <path d="M12 1L18 7L12 13" stroke="currentColor"></path>
//                             <path d="M18 7H0" stroke="currentColor"></path>
//                         </svg>
//                     </PageLink>
//                 </li>
//             )}

//             {first && (
//                 <>
//                     <li>
//                         <PageLink {...pageLinkProps(first)} ariaLabel="First page">
//                             {first.page}
//                         </PageLink>
//                     </li>
//                     <li><span class="ns-d-block ns-py-2 ns-px-4">...</span></li>
//                 </>
//             )}

//             {pages.map(page => (
//                 // ns-background-primary-light
//                 <li key={page.page} class={`${page.current ? "ns-active ns-color-black" : ""}`}>
//                     <PageLink ariaLabel={`${page.page} page`} {...pageLinkProps(page)}>{page.page}</PageLink>
//                 </li>
//             ))}

//             {last && (
//                 <>
//                     <li class="ns-d-flex ns-align-items-center"><span class="ns-py-2 ns-px-4">...</span></li>
//                     <li>
//                         <PageLink {...pageLinkProps(last)} ariaLabel="Last page">{last.page}</PageLink>
//                     </li>
//                 </>
//             )}

//             {next && (
//                 <li class="ns-d-flex ns-align-items-center">
//                     <PageLink {...pageLinkProps(next)} className="ns-next" ariaLabel="Next page">
//                         {/* <Icon name="arrow" className="ns-page-next-icon" /> */}
//                         <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5">
//                             <path d="M12 1L18 7L12 13" stroke="currentColor"></path>
//                             <path d="M18 7H0" stroke="currentColor"></path>
//                         </svg>
//                     </PageLink>
//                 </li>
//             )}
//         </ul>
//     )
// }
